import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import { useEffect, useState } from "react";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { assignDeliveryAgent, deliveryAgentsQuery } from "../graphQl";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialInput from "../../../../components/MaterialInput";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const AssignDeliveryForm = ({open = false, setOpen ,returnsData, fetchReturnsData}) => {
    const location = useLocation();
    const rowId = returnsData?.rowId;
    const customerName = returnsData?.returnsData?.customerName;
    const [deliveryAgent, setDeliveryAgent] = useState("");
    const [deliveryAgentOptions, setDeliveryAgentOptions] = useState([]);
    
    useEffect(() => {
        fetchDeliveryAgents();
    },[])
    const handleClose = () => {
        setOpen(false);
    };

    //Fetch Delivery Agent API 
    const fetchDeliveryAgents = async() => {
        try{
            const response = await request(BASEURL, deliveryAgentsQuery);
            const responseData = response.allUsers;
                const deliveries = responseData?.map((employee) => ({
                    label: employee.employeeName,
                    value: employee.id,
                    role: employee.role?.role ?? "",
                }));
            setDeliveryAgentOptions(deliveries);
        }
        catch(error){
            console.error("Error fetching delivery agent",error);
        }
    };

    //Submit Delivery Agent API
    const submitDeliveryAgent = async() => {
        try{
            const values = {
                returnId: rowId,
                deliveryAgentId: deliveryAgent.value
            }
            const response = await request(BASEURL, assignDeliveryAgent,{
                input: values
            });
            const successStatus = response?.assignDeliveryAgent?.success;
            const responseMessage = response?.assignDeliveryAgent?.message;
            if(successStatus){
                //success
                handleClose(); //close pop up
                Swal.fire({
                    position: "top",
                    icon: "success",
                    title: responseMessage,
                    showConfirmButton: true,
                })
                fetchReturnsData();     
            }
            else{
                //error
                Swal.fire({
                    position: "top",
                    icon: "error",
                    title: responseMessage,
                    showConfirmButton: true,
                });
            }
        }
        catch(error){
            console.error("Error submitting Delivery Agent",error);
        }
    };

    //Handle Change for delivery Agent field
    const handleChange = (event, selectEvent) => {
         if (!event?.target && selectEvent)  {
        switch(selectEvent.name){
            case "deliveryAgent": {
                setDeliveryAgent(event);
            }
        }
       } 
    };

    //submit validation
    const checkField = () => {
        let allowSubmit = false;
        if(
            deliveryAgent!= ""
        )
        {
            allowSubmit = true;
        }
        else{
            allowSubmit = false;
        }
        return allowSubmit;
    }



  return (
    <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
            Assign Delivery Agent
        </DialogTitle>
        <DialogContent>
            <Box mb={12}>
                <Grid container spacing={2}>
                    <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Delivery Agents
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="deliveryAgent"
                        value={deliveryAgent}
                        options={deliveryAgentOptions}
                        onChange={handleChange}
                        // menuPlacement="top"
                        />
                    </Grid>
                    <Grid size={{ lg: 12, xs: 12, sm: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Customer Name
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        value={customerName || "N/A"}
                        disabled
                        />
                    </Grid>
                </Grid>
            </Box>
        </DialogContent>
        <DialogActions>
            <MaterialBox
            display="flex"
            justifyContent="left"
            >
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleClose}
                >
                Cancel
                </MaterialButton>
            </MaterialBox>
            <MaterialBox
            display="flex"
            justifyContent="right"
            >
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={submitDeliveryAgent}
                disabled={!checkField()}>
                    Assign
                </MaterialButton>
            </MaterialBox>
           
        
           
        </DialogActions>
    </Dialog>
  )
}

export default AssignDeliveryForm